<ng-container *ngIf="templateSettings">
    <ng-container
        *ngIf="{
            templateConfiguration: templateConfiguration$ | async
        } as data"
    >
        <ng-container *ngIf="hasCmsStyles; else productTemplate">
            <div class="grid-{{ templateSettings.name }}-wrap" [ngStyle]="templateCmsStyles">
                <ng-container *ngTemplateOutlet="productTemplate"></ng-container>
            </div>
        </ng-container>

        <ng-template #productTemplate>
            <ul class="grid-product-wrap--{{ templateSettings.name }} {{ templateSettings.ulClasses }}">
                <li
                    class="grid-product-list grid-product-list--{{ templateSettings.name }} {{ skeletonClass }} 
                {{ templateSettings.liClasses }}"
                >
                    <ng-container>
                        <product-view
                            class="p-view"
                            [productId]="products[0]"
                            [config]="data.templateConfiguration"
                            [categoryConfig]="categoryConfiguration"
                            [productStyle]="productStyle"
                            [elementIndex]="elementIndex"
                            [defaultImageType]="elementDefaultImageTypes?.[products[0]]"
                            (clickActionBadge)="addToCartSheet($event)"
                        ></product-view>
                    </ng-container>
                </li>
            </ul>
        </ng-template>
    </ng-container>
</ng-container>
